import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (e2) {
      setErr(apiErr(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background grain">
      <div className="w-full max-w-sm relative z-10">
        <h1 className="font-heading text-2xl font-extrabold uppercase mb-2">Set new password</h1>
        {!token ? (
          <p className="text-sm text-red-400">Invalid reset link.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="password">New password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                minLength={8} data-testid="reset-password" className="mt-1" />
            </div>
            {err && <p className="text-sm text-red-400">{err}</p>}
            <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full font-bold uppercase">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
            </Button>
            <Link to="/login" className="text-sm text-muted-foreground hover:text-primary block text-center">Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
